const showAddOn = () => {
  const $atcBtn = document.querySelector("#cta-wrapper") as HTMLElement;
  const $addOn = document.querySelector(".add-on") as HTMLElement;
  $addOn.classList.add("active");

  if ($atcBtn && $addOn) {
    $atcBtn.addEventListener("click", () => {
      setTimeout(function () {
        // $addOn.classList.add("active");
      }, 1800);
    });
  }
};

export { showAddOn };
